
import { getNonEmpty } from '../../../../utils/helpers';
import EditIcon from "@material-ui/icons/Edit";
import { buttonsStyle } from "../../../components/tables/table";
import {
    Button,
    Tooltip
} from "@material-ui/core";
import { shallowEqual, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import { NewTable } from "../customers/EditCustomerPage";
import { useState } from 'react';
import { alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';

export default function TableTypeTech({ data, setData, setTypesOpen, setTypeSelected, tableKey, setTableKey }) {
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [titleEn, setTitleEn] = useState(null);


    function buttonFormatter(elem) {

        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setTypeSelected(elem)
                            setTypesOpen(true)
                        }
                        }
                    >
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setTitleEn(elem.title?.en)
                                    setOpenConfirmDialog(true)
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </>
        );
    }

    const columns = [
        { dataField: "title", text: "Title", formatter: (cell, row) => getNonEmpty(row.title) },
        { dataField: "", text: "", formatter: (_, row) => buttonFormatter(row), headerStyle: { width: '150px' } },
    ];


    return (
        <>
            <div className="col-12">
                <NewTable key={tableKey} data={data} columns={columns} />
            </div>

            <ConfirmDialog
                title={"Are you sure you want to delete this type?"}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    const updatedData = data.filter(item => item.title?.en !== titleEn)
                    setData([...updatedData]);
                    setTableKey(k => k + 1);
                    alertSuccess({
                        title: "Deleted!",
                        customMessage: "Type deleted successfully.",
                    });
                }}
            />
        </>
    );


}